import React from 'react';
import Header from "../header/Header";
import Footer from "../footer/Footer";
import TopGalleryProduct from "./TopGalleryProduct";
import IconName from "../../svgLogo/SvgLogo";
import MenuScrollSpy from "./MenuScrollSpy";
import ModalGalleryResponsive from "./gallery/modalGalleryResponsive";
import RelatedProducts from "./RelatedProducts";
import Sellers from "./Sellers";
import StudyProduct from "./StudyProduct";
import SpecificationsProduct from "./SpecificationsProduct";
import Bundle from "./Bundle";
import Comparison from "./Comparison";
import Chart from "./Chart";
import Comments from "./Comments";
import BuyPage from "./buyPage/BuyPage";
import BuyPageResponsive from "./buyPage/BuyPageResponsive";
import OutOfProduct from "./OutOfProduct";

const SinglePage = () => {
    return (
        <div
            className="single-page">
            <div className="title-buy-page-header">
                <IconName name="arrow_back" className="icon"/>
                <h2 className="title">Xiaomi Redmi Note 9 Pro Global Dual SIM 64GB- 6GB RAM</h2>
            </div>
            <div className="bg-gallery-modal bg-modal-desktop">
                <div className="close-button position-absolute">
                    <IconName name="expand_close" className="icon"/>
                </div>
            </div>
            <Header/>
            <div className="single-page-wrapper xmt-16 xpt-4">
                <div id="product-scroll">
                    <TopGalleryProduct/>
                    {/*<OutOfProduct/>*/}
                </div>
                <MenuScrollSpy/>
                <RelatedProducts/>
                <div id="sellers-scroll">
                    <Sellers/>
                </div>
                <div id="study-scroll">
                    <StudyProduct/>
                </div>
                <div id="technical-specifications-scroll">
                    <SpecificationsProduct/>
                </div>
                <div id="bundle-scroll">
                    <Bundle theme="blue"/>
                </div>
                <div id="category-scroll">
                    <Comparison/>
                </div>
                <div id="timeline-scroll">
                    <Chart/>
                </div>
                <div id="comments-scroll">
                    <Comments/>
                </div>

                <div id="overlay">
                </div>
                <div className="d-block d-lg-none">
                    <ModalGalleryResponsive/>
                </div>
                <div className="buy-page">
                    <BuyPage/>
                </div>
                <div className="buy-page-responsive">
                    <BuyPageResponsive/>
                </div>
            </div>
            <Footer/>
        </div>
    );
};

export default SinglePage;
